<template>
  <BasePopover v-bind="popoverAttrs"
               v-on="$listeners"
               :byClick="true"
               :disablePopover="disablePopover"
               :toggle="toggle"
               @click-outside="close"
               @popover-updated="onPopoverUpdated">
    <template v-slot:trigger>
      <slot name="trigger" />
    </template>
    <template v-slot:content>
      <slot name="content" />
    </template>
  </BasePopover>
</template>

<script>
  import BasePopover from '@base/base-popover'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'PopoverPrimary',
    inheritAttrs: false,
    components: {
      BasePopover,
    },
    props: {
      disablePopover: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        popoverAttrs: {
          borderRadius: Layout.space.sm,
          marginTop: Layout.space.xs,
          padding: `2px ${Layout.space.sm}`,
          zIndex: 1,
        },
        show: false,
        toggle: false,
      };
    },
    created: function () {
      this.popoverAttrs = {
        ...this.popoverAttrs,
        backgroundColor: this.color.dark3(),
        border: `solid 1px ${this.color.dark3()}`,
        color: this.color.light1(),
        ...this.$attrs,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    methods: {
      close: function () {
        if (this.show) {
          this.toggle = !this.toggle;
        }
      },
      onPopoverUpdated: function (show) {
        this.show = show;
      },
    },
  };
</script>
